import { render, staticRenderFns } from "./ManagerStats.vue?vue&type=template&id=130f7113&scoped=true"
import script from "./ManagerStats.vue?vue&type=script&lang=js"
export * from "./ManagerStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130f7113",
  null
  
)

export default component.exports